module.exports = __webpack_public_path__ + "static/maza-yeshu-mark-tribhuvan-14baed9376eb447e0723da742111b7a2.jpg";